import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { selectCaseta } from '../../state/selectors/caseta.selectors';
import { selectCruce } from '../../state/selectors/cruce.selectors';
import { Caseta, Cruce } from '../../models';

@Component({
  selector: 'app-retornos',
  templateUrl: './retornos.component.html',
  styleUrls: ['./retornos.component.scss']
})
export class RetornosComponent implements OnInit {
  hora = '';
  id_carril = '';
  comentarioOperativo = '';
  caseta : Caseta;
  cruce:any;
  selected:boolean = false;
  id_corte_auxiliar : number = 0;
  user: any
  carriles = [
    { id: 1, nombre: 'Carril 1' },
    { id: 2, nombre: 'Carril 2' },
    { id: 3, nombre: 'Carril 3' }
  ];

  comentarioOptions: any[] = [];
  provenienciaOptions: any[] = [];
  usuario: any = null;
  fechaMinima: string = '';
  fechaMaxima: string = '';

  constructor(
    private store: Store<AppState>,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.store.select(selectUser).subscribe((user) => {
      this.usuario = user;
      this.user = user;
      this.loadObservacionOptions();
    });
    this.store.select(selectCaseta).subscribe(caseta=>this.caseta=caseta);
    this.store.select(selectCruce).subscribe(cruce=>this.cruce=cruce);
    this.calcularFechaMinima();
  }
 calcularFechaMinima() {
  const ahora = new Date();

  // Fecha mínima: 30 minutos a partir de ahora
  const fechaMinima = new Date(ahora);
  fechaMinima.setMinutes(fechaMinima.getMinutes() - 30);

  // Fecha máxima: 10 días a partir de ahora
  const fechaMaxima = new Date(ahora);
  fechaMaxima.setDate(fechaMaxima.getDate());

  // Ajustar a zona horaria local
  const formatearFechaLocal = (fecha: Date): string => {
    const tzOffset = fecha.getTimezoneOffset() * 60000;
    return new Date(fecha.getTime() - tzOffset)
      .toISOString()
      .slice(0, 16);
  };

  this.fechaMinima = formatearFechaLocal(fechaMinima);
  this.fechaMaxima = formatearFechaLocal(fechaMaxima);
}
  private loadObservacionOptions(): void {
    const comentarioData = localStorage.getItem('catObservacionComentario');
    const retornoProvenenciaData = localStorage.getItem('catObservacionRetornoProvenencia');

    if (comentarioData) {
      try {
        this.comentarioOptions = JSON.parse(comentarioData);
      } catch (error) {
        console.error('Error parsing comentario data', error);
        this.comentarioOptions = [];
      }
    }

if (retornoProvenenciaData) {
  try {
    const parsed = JSON.parse(retornoProvenenciaData);
    const items = Array.isArray(parsed) ? parsed : [];

    const selectedCarril = localStorage.getItem('id_carril');

    this.provenienciaOptions = items.find((item: any) => {
      return item.id_carril == selectedCarril;
    }).carriles || [];

    console.log('Carril de la tablet:', selectedCarril);
    console.log('Proveniencias filtradas:', this.provenienciaOptions);

  } catch (error) {
    console.error(
      'Error parsing retorno proveniencia data',
      error
    );

    this.provenienciaOptions = [];
  }
}
  }

  continuar(): void {
    const payload = {
      hora: this.hora,
      id_carril: this.id_carril,
      comentarioOperativo: this.comentarioOperativo,
      usuario: this.usuario,
    //   caseta: this.caseta,
      cruce: this.cruce,
      fecha: new Date().toISOString()
    };

    localStorage.setItem('retornosData', JSON.stringify(payload));
    console.log('Datos de retornos guardados:', payload);
    this.router.navigate(['/mopa/clasificacion-vehicular']);
  }
}
